// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./css/components/product-item/_index.scss
// module id = 71
// module chunks = 0